import api from '@utils/api';
import Smooch from 'smooch';
const sendMessage = (message) => {
    let conversation = Smooch.getDisplayedConversation();
    if (conversation == null || conversation == undefined) {
        Smooch.createConversation({
            messages: [message],
        }).then(() => { });
    }
    else {
        let conversationId = conversation.id;
        Smooch.sendMessage(message, conversationId);
    }
};
const addStyleToChatWrapper = () => {
    let timerId = setInterval(() => {
        var _a;
        let chatWrapper = document.getElementById('web-messenger-container').contentDocument;
        if ((_a = chatWrapper === null || chatWrapper === void 0 ? void 0 : chatWrapper.head) === null || _a === void 0 ? void 0 : _a.appendChild) {
            clearTimeout(timerId);
            document.getElementById('web-messenger-container').hidden = true;
            const linkEl = document.createElement('link');
            linkEl.setAttribute('rel', 'stylesheet');
            linkEl.setAttribute('href', `${window.staticurl}chat.css`);
            linkEl.setAttribute('href', `${window.staticurl.replace('/images/', '/css/main.css')}`);
            let chatWrapper = document.getElementById('web-messenger-container').contentDocument;
            chatWrapper.head.appendChild(linkEl);
            chatWrapper.head.insertAdjacentHTML('beforeend', '<base target="_parent">');
        }
    }, 200);
};
export const sendInfoJSON = (user, minicart) => {
    var _a;
    let profile = {};
    if (user.isAuthenticated) {
        profile = {
            email: user.email,
            firstName: user.firstName,
            gender: user.gender,
            lastName: user.lastName,
            phone: user.phone,
            phonePrefix: user.phonePrefix,
            preferredLocale: user.preferredLocale,
            crmID: user.dynamicsCrmID,
        };
    }
    let infoJson = {
        pageUrl: location.href,
        profile: profile,
        pageInfo: {
            country: window.datalayerdata.pageCountry,
            language: window.locale.replace('_', '-').toLowerCase(),
            pageCategory: window.datalayerdata.pageCategory,
        },
        shoppingBag: {
            items: minicart.items.map((item) => {
                var _a, _b, _c, _d, _e;
                return ({
                    dimension52: (_a = item.analyticsAttributes) === null || _a === void 0 ? void 0 : _a.dimension52,
                    img: (_b = item.imgs) === null || _b === void 0 ? void 0 : _b.alt,
                    price: (_d = (_c = item.price) === null || _c === void 0 ? void 0 : _c.sales) === null || _d === void 0 ? void 0 : _d.formatted,
                    quantity: item.quantity,
                    variationAttributes: (_e = item.variationAttributes) === null || _e === void 0 ? void 0 : _e.map((variations) => {
                        const selected = variations.values.find((val) => val.selected);
                        return {
                            displayValue: variations.displayValue,
                            id: variations.id,
                            productId: selected.productId,
                            productUrl: selected.productUrl,
                        };
                    }),
                });
            }),
            totals: (_a = minicart === null || minicart === void 0 ? void 0 : minicart.totals) === null || _a === void 0 ? void 0 : _a.grandTotal,
        },
    };
    sendMessage({
        type: 'text',
        text: JSON.stringify(infoJson),
        metadata: {
            isHidden: true,
            isWebInfoJson: true,
        },
    });
};
export const sendIsOnlineRequest = async (IntegrationId, LanguageCode, ConversationId) => {
    // sendMessage({
    //   type: 'text',
    //   text: '{isCustomerServiceOnline?}',
    //   metadata: {
    //     isHidden: true,
    //   },
    // });
    addStyleToChatWrapper();
    return api.isWebChatAvailable(IntegrationId, LanguageCode, ConversationId);
};
export const removeChatInfosFromStorage = (id) => {
    const integrationId = id || JSON.parse(localStorage.getItem('livechatid') || '{}').value;
    if (integrationId) {
        localStorage.removeItem('livechatid');
        localStorage.removeItem(`${integrationId}.sessionToken`);
        localStorage.removeItem(`${integrationId}.clientId`);
        localStorage.removeItem(`${integrationId}.appUserId`);
    }
};
